import React, { useEffect, useState, useRef } from "react";
import { useUsermaven } from "@usermaven/react";

interface ABIGAILProps {
  onExit: (to: string) => void;
}

interface AXISXY {
  x: {
    pos: number;
    value: number;
  };
  y: {
    pos: number;
    value: number;
  };
}

const ABIGAIL: React.FC<ABIGAILProps> = ({ onExit }) => {
  const { track } = useUsermaven();

  const video = useRef<HTMLVideoElement>(null);

  const CLL13 = useRef<HTMLDivElement>(null);
  const CAPTIVATE = useRef<HTMLDivElement>(null);
  const AMPLIFY = useRef<HTMLDivElement>(null);
  const ESMO = useRef<HTMLDivElement>(null);

  const [timeStamp, setTimeStamp] = useState<number | null>(null);
  const [animType, setanimType] = useState<string>("");

  const setAxis = ({ name, position }: { name: 'CLL13' | 'CAPTIVATE' | 'AMPLIFY' | 'ESMO'; position: AXISXY }): void => {
    const refMap = {
      CLL13,
      CAPTIVATE,
      AMPLIFY,
      ESMO,
    };

    const element = refMap[name]?.current;

    if (!element) return;

    element.style.top = `${position.y.pos}%`;
    element.style.left = `${position.x.pos}%`;
    element.style.width = `${position.x.value}px`;
    element.style.height = `${position.y.value}px`;
  }

  switch (animType) {
    case "INTRO":
      setAxis({ name: "CLL13", position: { x: { pos: 29, value: 450 }, y: { pos: 43, value: 200 } } });
      setAxis({ name: "CAPTIVATE", position: { x: { pos: 52.8, value: 400 }, y: { pos: 43, value: 200 } } });
      setAxis({ name: "AMPLIFY", position: { x: { pos: 74.5, value: 400 }, y: { pos: 43, value: 200 } } });
      setAxis({ name: "ESMO", position: { x: { pos: 30, value: 850 }, y: { pos: 63.5, value: 100 } } });
      break;
    case "TIMELINE":
      setAxis({ name: "CLL13", position: { x: { pos: 52, value: 160 }, y: { pos: 6, value: 50 } } });
      setAxis({ name: "CAPTIVATE", position: { x: { pos: 60.5, value: 158 }, y: { pos: 6, value: 50  } } });
      setAxis({ name: "AMPLIFY", position: { x: { pos: 68.9, value: 160 }, y: { pos: 6, value: 50  } } });
      setAxis({ name: "ESMO", position: { x: { pos: 77.5, value: 166 }, y: { pos: 6, value: 50  } } });
      break;
    default:
      break;
  }


  useEffect(() => {
    track("Case Jeremy");
  }, []);

  useEffect(() => {
    console.log('timeStamp', timeStamp);

    if (timeStamp === null) return;

    if(timeStamp >= 6 && timeStamp <= 15)
      setanimType("INTRO");
    else if (timeStamp > 15)
      setanimType("TIMELINE");

  }, [timeStamp])
  
  const transitionTo = (to: number) => {
    if (video.current) {
      return video.current.currentTime = to;
    }
  }

  useEffect(() => {
    track("Case Abigail");
  }, []);

  const transitionBack = () => {
    onExit("/menu");
  };

  return (
    <div id="profile_abigail" className="h-screen w-screen">
      <div
        className="w-40 h-40 absolute left-0 top-0 z-10"
        onClick={() => transitionBack()}
      ></div>

        <div ref={CLL13} onClick={() => transitionTo(18.5)} className={`fixed bg-red-500 opacity-0 z-20`}></div>
        <div ref={CAPTIVATE} onClick={() => transitionTo(38)} className={`fixed bg-black opacity-0 z-20`}></div>
        <div ref={AMPLIFY} onClick={() => transitionTo(58)} className={`fixed bg-blue-500 opacity-0 z-20`}></div>
        <div ref={ESMO} onClick={() => transitionTo(76)} className={`fixed bg-green-500 opacity-0 z-20`}></div>

      <video
        className="h-full w-full object-cover"
        autoPlay
        playsInline
        muted
        // controls
        onTimeUpdate={(event: any) => {
          setTimeStamp(Math.round(event.target.currentTime));
        }}
        onEnded={() => transitionBack()}
        ref={video}
      >
        <source src="../assets/profiles/abigail_content.mp4?v=2" />
      </video>
    </div>
  );
};

export default ABIGAIL;
